import { produce } from 'immer';
import { getUserQueryKey } from './query-key';
export const invalidateUserQuery = (queryClient) => queryClient.invalidateQueries({ queryKey: getUserQueryKey });
export const getUserQueryData = (queryClient) => queryClient.getQueryData(getUserQueryKey);
export function setUserQueryData(queryClient, updater) {
    queryClient.setQueryData(getUserQueryKey, (oldData) => produce(oldData, updater));
}
//# sourceMappingURL=query.js.map